// src/actions/revenue_bridge_actions.js
//
// The revenue bridge — the reconciliation behind the headline number, plus the
// mirror's health.
//
// The API has served this for a while and NOTHING in the dashboard read it, which
// meant two things were invisible to anyone actually using the product:
//
//   1. mirror.stale — sync health. Nothing feeds the order mirror except an hourly
//      job; if it stops, every windowed read returns empty and the dashboard draws
//      a confident $0. That has happened. The heartbeat that detects it was built
//      and verified, but only reachable by curl — so the protection existed and no
//      operator could see it.
//
//   2. the reconciliation lines. When someone asks "why is revenue lower than I
//      expected", the answer is cancelled / testOrders / refunds / chargeVariance.
//      Without them the drop looks like lost business rather than excluded
//      non-business.
//
// Same conventions as the other action files: plain axios + the jwtToken bearer.
import axios from "axios";

export const RB_LOADING = "RB_LOADING";
export const RB_SUCCESS = "RB_SUCCESS";
export const RB_FAIL = "RB_FAIL";

export const fetchRevenueBridge =
  ({ range = "last30d", currency = "USD", refundBasis = "order" } = {}) =>
  async (dispatch) => {
    dispatch({ type: RB_LOADING });
    try {
      const token = localStorage.getItem("jwtToken");
      const url =
        `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/revenue-bridge` +
        `?range=${encodeURIComponent(range)}&currency=${encodeURIComponent(currency)}` +
        `&refundBasis=${encodeURIComponent(refundBasis)}`;
      const resp = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      const data = resp?.data?.data || {};
      // `supported: false` is a real, expected answer — the bridge is backed by the
      // commerce mirror, which holds USD only. Surfaced rather than treated as an
      // error, so a GBP/INR view explains itself instead of looking broken.
      dispatch({ type: RB_SUCCESS, payload: data });
    } catch (e) {
      dispatch({
        type: RB_FAIL,
        payload: e?.response?.data?.message || e.message || "Could not load the revenue bridge",
      });
    }
  };
